import { render, staticRenderFns } from "./NewCouponModal.vue?vue&type=template&id=10ac8146&scoped=true"
import script from "./NewCouponModal.vue?vue&type=script&lang=js"
export * from "./NewCouponModal.vue?vue&type=script&lang=js"
import style0 from "./NewCouponModal.vue?vue&type=style&index=0&id=10ac8146&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ac8146",
  null
  
)

export default component.exports